import { IAppState } from '../../../AppModulesWrapper';
import { EPaymentProvider } from '../../../PaymentWidgetMicrofrontend';

export function selectDepositAccountProvider(state: IAppState): EPaymentProvider | null {
  return state.servicePickerWidget.depositAccount.provider;
}
